module.exports = __webpack_public_path__ + "static/media/image51.6ad27039.png";